import React from 'react';
import styles from './PlayButton.module.css';

interface PlayButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isPlaying?: boolean;
  className?: string;
  /** The key that plays this clip again (named for assistive tech and in the tooltip). */
  shortcut?: string;
}

export const PlayButton: React.FC<PlayButtonProps> = ({
  onClick,
  disabled = false,
  isPlaying = false,
  className,
  shortcut,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`${styles.playButton} ${className || ''}`}
      aria-label={isPlaying ? 'Pause audio' : 'Play audio'}
      aria-keyshortcuts={shortcut}
      title={
        shortcut
          ? `${isPlaying ? 'Pause audio' : 'Play audio'} (${shortcut})`
          : undefined
      }
    >
      {isPlaying ? '⏸' : '▶'}
    </button>
  );
};

export default PlayButton;
